export default __webpack_public_path__ + "555b120cba4dfab5e47d8afd37dc873a.png";